"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var __1 = require("..");
var util_localization_1 = require("@sport-thieme/util-localization");
function ContextMenu(_a) {
    var actions = _a.actions, children = _a.children;
    var _b = react_1.useState(initialAnchorPosition), _c = _b[0], mouseX = _c.mouseX, mouseY = _c.mouseY, setAnchorPosition = _b[1];
    var handleContextMenu = function (event) {
        event.preventDefault();
        setAnchorPosition({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    };
    var handleClose = function () {
        setAnchorPosition(initialAnchorPosition);
    };
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", __assign({ onContextMenuCapture: handleContextMenu }, { children: children }), void 0),
            jsx_runtime_1.jsx(core_1.Menu, __assign({ disableAutoFocusItem: false, open: mouseY !== null, onClose: handleClose, anchorReference: "anchorPosition", anchorPosition: mouseY !== null && mouseX !== null ? { top: mouseY, left: mouseX } : undefined }, { children: actions.map(function (_a, index) {
                    var _b = _a.button, button = _b === void 0 ? true : _b, _c = _a.autoFocus, autoFocus = _c === void 0 ? false : _c, children = _a.children, onClick = _a.onClick, label = _a.label, confirm = _a.confirm, icon = _a.icon, action = __rest(_a, ["button", "autoFocus", "children", "onClick", "label", "confirm", "icon"]);
                    var handleClick = function (event) {
                        handleClose();
                        onClick === null || onClick === void 0 ? void 0 : onClick(event);
                    };
                    var menuItem = (jsx_runtime_1.jsx(core_1.MenuItem, __assign({ autoFocus: autoFocus, onClick: handleClick, button: button }, action, { children: jsx_runtime_1.jsxs(__1.Grid, __assign({ container: true, spacing: 4, alignContent: "center" }, { children: [jsx_runtime_1.jsx(__1.Grid, __assign({ item: true, grow: true }, { children: label || children }), void 0),
                                Boolean(icon) && jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: icon }), void 0)] }), void 0) }), label + "-" + index));
                    if (confirm) {
                        var question = typeof confirm === 'string' ? confirm : util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Are you sure?"], ["Are you sure?"])));
                        return (jsx_runtime_1.jsx(__1.Confirmation, __assign({ question: question, onCancel: handleClose }, { children: menuItem }), label + "-" + index));
                    }
                    return menuItem;
                }) }), void 0)] }, void 0));
}
exports.default = ContextMenu;
var initialAnchorPosition = {
    mouseX: null,
    mouseY: null,
};
var templateObject_1;
//# sourceMappingURL=ContextMenu.js.map